export const DOUBLE_RUN_ROUTE = 'Double Run Route';
export const DOUBLE_RUN_ROUTE_MESSAGE_PT_1 =
  'Please Make Sure The Original Route Is Departed';
export const DOUBLE_RUN_ROUTE_MESSAGE_PT_2 =
  'Before Proceeding Otherwise It Will Be Unusable';
export const DOUBLE_RUN_ROUTE_VOID_MESSAGE =
  'You cannot create a double run route as route number is void';
